import script from "./UserSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSignup.vue?vue&type=script&setup=true&lang=js"

import "./UserSignup.vue?vue&type=style&index=0&id=c5addb84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5addb84"]])

export default __exports__